import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref } from "@eastsideco/salvo-ts";
import Player from '@vimeo/player';
import YT from 'youtube-player';
import { YouTubePlayer } from "youtube-player/dist/types";
import Plyr from 'plyr';

/**
 * ----------------------------------------------------------------------------
 * Component: Video Player
 * - Creates featured video element for used with YouTube, Vimeo & Shopify
 * hosted videos.
 * ------------------------------------------------------------------------------
 */
@Component
export class VideoPlayer extends ThemeComponent  {
    @Prop background!: boolean;
    @Ref({required: false}) video!: HTMLVideoElement|HTMLIFrameElement|HTMLDivElement;
    @Ref({required: false}) trigger!: HTMLButtonElement;
    @Ref({required: false}) close!: HTMLButtonElement;
    @Ref({required: false}) popup!: HTMLDivElement;

    private player!: Plyr;

    init() {
        if (!this.video) { return; }

        if (this.background) {
            if (this.video instanceof HTMLVideoElement) {
                const videoEl = this.video;
                videoEl.muted = true;
                videoEl.playsInline = true;
                void videoEl.play();

                videoEl.addEventListener('loadedmetadata', () => {
                    void videoEl.play();
                }, { once: true });
            }

            return;
        }

        this.player = new Plyr(this.video);

        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    private setEventListeners() {
        if (!this.trigger) { return; }

        this.$listen(this.trigger, 'click', () => {
            this.handlePopup();

            document.body.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.handleClose();
                }
            });
        });

        this.$listen(this.close, 'click', () => {
            this.handleClose();
        });
    }

    /**
     * Handle video popup open.
     */
    private handlePopup() {
        this.popup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        this.player.togglePlay();
    }

    /**
     * Handle video popup close.
     */
    private handleClose() {
        this.popup.classList.remove('is-active');
        document.body.style.overflow = 'auto';
        this.player.pause();
    }
}
